import React from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import INBDETableRowActions from '../table/INBDETableRowActions';
import RandomExportService from '../../services/RandomExport/RandomExportService';
import { downloadFileFromUrl } from '../../helpers/utils';

const randomExportService = new RandomExportService();

const PastRandomSetsTableRowActions = ({ path, url }) => {
  // the stored link is used when there is one, and the path is resolved again
  // when there is not, so a row whose archive has gone says so instead of
  // opening a dead tab
  const downloadRandomSet = async () => {
    const downloadUrl = url || (await randomExportService.getRandomExportDownloadUrl(path));

    if (!downloadUrl) {
      toast.error('This archive is no longer available for download');
      return;
    }

    downloadFileFromUrl(downloadUrl);
  };

  const actions = [
    {
      key: 0,
      id: 0,
      label: (
        <>
          Download<span className="sr-only"> (zip file)</span>
        </>
      ),
      isMenuItem: true,
      onClickAction: () => downloadRandomSet(),
      className: 'text-primary',
      isHide: false
    }
  ];

  return <INBDETableRowActions actionItems={actions} />;
};

PastRandomSetsTableRowActions.propTypes = {
  path: PropTypes.string,
  url: PropTypes.string
};

export default PastRandomSetsTableRowActions;
